import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import type { ITopWorkerProfit } from '@/entities/admin-stats.entity';
import { formatProfitUsd } from '@/lib/format-profit';
import { DollarSignIcon } from 'lucide-react';
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts';

interface TopWorkersProfitChartProps {
	data: ITopWorkerProfit[];
}

const chartConfig = {
	profitUsd: { label: 'Профит', color: 'var(--chart-5)' },
};

export default function TopWorkersProfitChart({ data }: TopWorkersProfitChartProps) {
	const chartData = data.map(d => ({
		name: `#${d.nickname}`,
		profitUsd: d.profitAmount / 100,
	}));

	return (
		<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
			<CardHeader className='border-b px-4 py-3'>
				<div className='flex items-center gap-2'>
					<div className='rounded-lg bg-chart-5/15 p-1.5'>
						<DollarSignIcon className='text-chart-5' size={16} />
					</div>
					<CardTitle className='text-sm'>Топ воркеров по профитам</CardTitle>
				</div>
			</CardHeader>
			<CardContent className='px-2 py-3'>
				{chartData.length === 0 ? (
					<div className='h-[200px] flex items-center justify-center text-sm text-muted-foreground'>Нет данных</div>
				) : (
					<ChartContainer config={chartConfig} className='w-full' style={{ height: Math.max(200, chartData.length * 36) }}>
						<BarChart data={chartData} layout='vertical' margin={{ top: 0, right: 8, left: 0, bottom: 0 }}>
							<CartesianGrid strokeDasharray='3 3' horizontal={false} />
							<XAxis type='number' tickLine={false} axisLine={false} tick={{ fontSize: 10 }} tickFormatter={v => `$${v}`} />
							<YAxis type='category' dataKey='name' tickLine={false} axisLine={false} tick={{ fontSize: 10 }} width={80} />
							<ChartTooltip
								content={
									<ChartTooltipContent formatter={value => `$${formatProfitUsd(Number(value) * 100)}`} />
								}
							/>
							<Bar dataKey='profitUsd' fill='var(--chart-5)' radius={[0, 4, 4, 0]} />
						</BarChart>
					</ChartContainer>
				)}
			</CardContent>
		</Card>
	);
}
